module.exports = __webpack_public_path__ + "static/media/key-2.69d6fd11.JPG";